/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Lock({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.883 9.97a.686.686 0 0 0-.097.385l.159 1.595a.5.5 0 0 1-.497.55h-.896a.5.5 0 0 1-.497-.55l.16-1.595a.686.686 0 0 0-.098-.385 1 1 0 1 1 1.766 0Z" /><path fill="currentColor" fillRule="evenodd" d="M4.4 5a3.6 3.6 0 0 1 7.2 0v.9h.4a2.6 2.6 0 0 1 2.6 2.6v5a1.6 1.6 0 0 1-1.6 1.6H3a1.6 1.6 0 0 1-1.6-1.6v-5A2.6 2.6 0 0 1 4 5.9h.4V5Zm6 0v.9H5.6V5a2.4 2.4 0 0 1 4.8 0ZM4 7.1a1.4 1.4 0 0 0-1.4 1.4v5c0 .22.18.4.4.4h10a.4.4 0 0 0 .4-.4v-5A1.4 1.4 0 0 0 12 7.1H4Z" clipRule="evenodd" /></svg>;
}
;